module.exports = __webpack_public_path__ + "img/Stortingsmelding-nr.-31_Bilde-av-Formann-i-Norsk-Lytterforening.-Kan-gjores-mindre..ba52603b.jpg";